import { setupAPIClient } from './apiCliente';

export const api = setupAPIClient();
